export default __webpack_public_path__ + "static/N0046-f29aad46c4d9505820a79ba5284f3c81.png";